(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('clan-size-chart-trigger')) {
    customElements.define('clan-size-chart-trigger', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.handleClick = () => {
          this.closest('.product-details')
            ?.querySelector('.popup-link--inline-target .popup-link__button')
            ?.click();
        };
        this.button?.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleClick);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
